module.exports = __webpack_public_path__ + "img/lightspeed.2084b95e.png";